module.exports = " <div id=\"timepicker-{{ _uid }}\" class=timepicker _v-3b64e956=\"\"> <label v-if=label for=\"timepicker-select-{{ _uid }}\" _v-3b64e956=\"\">{{ label }}</label> <select id=\"timepicker-select-{{ _uid }}\" class=form-control v-model=value :disabled=disabled _v-3b64e956=\"\"> <option v-for=\"(value, text) in timeOptions\" :value=value :selected=\"\" _v-3b64e956=\"\">{{ text }}</option> </select> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3b64e956!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ui/timepicker.vue
// module id = 283
// module chunks = 0